module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABZElEQVRIib3VvWoUURQA4LWRDTFJkQeQBMQmCdjkCUTzBHYJYREtN52V4CMIgpUgJI0sW1jlFXY3kHRBhS1ku1Tmh2STZj+LvSvjcPdndiZ7mjvcc858c2fuzJRKUwYqOEcbTRziAB/xHtvTnjuGvTMiCoNmFvhw7yvC61FI4bcO3SHObdFQawjUKBp6iV4K6eFFoVACa+ISjXtBZhZYQU3/K5GMasg/xvO8yFOcRTZCHQ/wMGyWdh5kHqcRpI2lUPNpMFnCEdlfLuxHkC6ehfyrZKL07yAb8iaCwNuQf4KLXBA2cBNBvoV8GSfpZCYIC/gZQX5hMdR8jS11Ykh/F9UTvVdhvMZaqKnEkKzQXqp3J4y7Ib8e0OkhbOIu0fc5zH8J4yP8GIZMBGEZvxM9xyiH3FwYa6OQsZD+c/meqP+D1VRNdRwygFqjVpQn/oNik2OvbtZQhpZOEhr2S05HIyPUwdZf5UJ8EKRih4EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_icon.png
// module id = 8oXN
// module chunks = 1